(function () {
  angular.module('eclipseApp.user').run(['passiveTracking', function (passiveTracking) {
    passiveTracking.init();
  }]);
}());
